import request from '@utils/request';
import { useQuery } from '@tanstack/react-query';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';
import { SPA_AVAILABILITY_TIMEOUT } from './consts';

export function useGetSpaPackageExtras(
  propertyId: number,
  spaPackageId: number,
  language: string,
  arrivalDate: string,
  isNonWebPackage?: boolean,
  enabled = true
) {
  return useQuery({
    queryKey: getSpaPackageExtrasKey(
      propertyId,
      spaPackageId,
      language,
      arrivalDate,
      isNonWebPackage
    ),
    queryFn: () =>
      getSpaPackageExtras(propertyId, spaPackageId, language, arrivalDate, isNonWebPackage),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled,
  });
}

export async function getSpaPackageExtras(
  propertyId: number,
  spaPackageId: number,
  language: string,
  date: string,
  isNonWebPackage?: boolean
) {
  let url = `${propertyId}/spa-packages/${spaPackageId}/${language}`;
  if (isNonWebPackage) {
    url += '?allow-non-web-packages=1';
  }
  const { data } = await request.get(url, {
    isPayloadCaseConverterDisabled: true,
    params: { date },
    timeout: SPA_AVAILABILITY_TIMEOUT,
  });
  const extras = data?.configurationGroups.filter((cg) => cg.isExtras);

  return extras as ConfigurationGroupType[];
}

const getSpaPackageExtrasKey = (
  propertyId: number,
  spaPackageId: number,
  language: string,
  arrivalDate: string,
  isNonWebPackage?: boolean
) => ['spaPackage', 'extras', propertyId, spaPackageId, language, arrivalDate, isNonWebPackage];
